import { getFirestore } from "firebase/firestore";
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFunctions, connectFunctionsEmulator } from "firebase/functions";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyA7_AA4TFFkW18TfHeQ-boB4KOCmWvEiNo",
  authDomain: "valsplat-b07bc.firebaseapp.com",
  projectId: "valsplat-b07bc",
  storageBucket: "valsplat-b07bc.firebasestorage.app",
  messagingSenderId: "511770769568",
  appId: "1:511770769568:web:03dc9d1c910460f347b1c5",
};

console.log("Starting Firebase");
let app = initializeApp(firebaseConfig);
const functions = getFunctions(app, "europe-west1");

// EMULATOR

let emulator = true;
if (emulator && window.location.origin.includes("localhost")) {
  console.log("Starting Functions Emulators");
  connectFunctionsEmulator(functions, "localhost", 5001);
}

// utils
const db = getFirestore(app);
const auth = getAuth(app);
const storage = getStorage(app);
// export utils/refs
export { db, auth, functions, storage };
